import { useLayoutEffect } from "react";

// Revela ao rolar os elementos marcados com [data-revelar] na página que chamar o hook: cada um
// sobe e esmaece para dentro quando entra na tela, uma vez só.
//
// Quem esconde é o CSS (src/styles/index.css), condicionado à classe `revelar-ativo` no <html>,
// que só este efeito adiciona. É isso que garante que o conteúdo nunca fica invisível quando o
// observer não roda — jsdom nos testes, navegador sem IntersectionObserver e qualquer crawler que
// não execute JS. A Home é a página de SEO do site: o texto dela não pode depender deste arquivo
// para existir. (Contra o Googlebot, que executa JS, quem resolve é outra coisa: ele renderiza
// num viewport artificialmente alto e sem rolar, então a página inteira intersecta de uma vez.)
//
// useLayoutEffect, e não useEffect: o useEffect roda depois da pintura, então haveria um quadro
// com tudo visível antes de a classe esconder — o visitante veria a página piscar.
export default function useRevelarAoRolar() {
	useLayoutEffect(() => {
		if (typeof IntersectionObserver === "undefined") return;

		const raiz = document.documentElement;
		const alvos = Array.from(document.querySelectorAll("[data-revelar]"));
		if (!alvos.length) return;

		raiz.classList.add("revelar-ativo");

		// rootMargin negativo embaixo: o bloco só conta como visto depois de entrar ~12% na tela.
		// Sem isso a animação dispara com o card ainda no vinco e termina antes de ser vista.
		const observer = new IntersectionObserver(
			(entradas) => {
				entradas.forEach((entrada) => {
					if (!entrada.isIntersecting) return;
					entrada.target.classList.add("revelado");
					// Uma vez só. Re-animar ao rolar de volta é a irritação clássica do padrão.
					observer.unobserve(entrada.target);
				});
			},
			{ rootMargin: "0px 0px -12% 0px" }
		);

		alvos.forEach((alvo) => observer.observe(alvo));

		return () => {
			observer.disconnect();
			raiz.classList.remove("revelar-ativo");
			alvos.forEach((alvo) => alvo.classList.remove("revelado"));
		};
	}, []);
}
